import { useEffect as d } from "react";
import { useLatestValue as a } from "./use-latest-value.js";

function s(e, r, n) {
  var o = a(r);
  d(function () {
    function t(i) {
      o.current(i);
    }

    return window.addEventListener(e, t, n), function () {
      return window.removeEventListener(e, t, n);
    };
  }, [e, n]);
}

export { s as useWindowEvent };